// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"c8c0aa82","1654":"2364ad0b","2495":"2364ad0b","7716":"f524e22f","8440":"2364ad0b","9285":"2364ad0b","9338":"24c1fb3e"}[chunkId] + ".chunk.css";
};